import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Loader from '../../../components/Loader.js';
import QuoteRequestSelect from '../../../components/DistrictQuote/districtQuoteRequest.js';
//V2
import { getDistrictQuotesV2 } from '../../../api/districtquoteapi.js'; //getDistrictQuotes
import { formatDateTimeForUserTimeZone } from '../../../helpers/DateTimeFormatter';
export default function DistrictQuoteRequests() {
    const { districtId } = useParams();
    const [loadingData, setLoadingData] = useState(true);
    const [quotes, setQuotes] = useState({ total: 0, results: [] });
    const [filter, setFilter] = useState({ start: 1, length: 100, search: '', status: -1, sort: 1, isdistrictRequest: true });
    const [expandedQuoteId, setExpandedQuoteId] = useState(null);
    const [selectedStatusRowIndex, setSelectedStatusRowIndex] = useState(null);
    const [manuallyCollapsedQuotes, setManuallyCollapsedQuotes] = useState(new Set());

    useEffect(() => {
        //V2  

        getDistrictQuotesV2(districtId, filter)
            .then((response) => {
                if (response.data.success) {
                    setQuotes(response.data.data);
                }                
                setLoadingData(false);
            });
    }, [filter]);

    const generatePageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(quotes.total / filter.length); i++) {
            pageNumbers.push(
                <button key={i}
                    onClick={() => { setFilter({ ...filter, start: filter.start + filter.length }); } }
                    className={Math.floor(filter.length) === i ? 'active' : ''}>{i}
                </button>
            );
        }
        return pageNumbers;
    };

    const handleStatusClick = (e, quote, index) => {
        e.stopPropagation();
        handleStatusOnEnter(quote, index);
    }

    const handleStatusOnEnter = (quote, index) => {
        const subQuoteStatus = quote?.subQuotes
            ?.map(sq => sq.statusText)
            ?.filter(Boolean) || [];

        const uniqueSubQuoteStatus = [...new Set(subQuoteStatus)];

        const multipleFromSubQuotes = uniqueSubQuoteStatus.length > 0;

        if (multipleFromSubQuotes) {
            setSelectedStatusRowIndex(index);
        }
    }
    const toggleQuoteExpand = (quote, isExpanded, isEditable) => {
        const newIsExpanded = !isExpanded;

        if (newIsExpanded) { 
            setManuallyCollapsedQuotes(prev => {
                const updated = new Set(prev);
                updated.delete(quote.id);
                return updated;
            });
            setExpandedQuoteId(quote.id);
        } else { 
            if (isEditable) {
                setManuallyCollapsedQuotes(prev => {
                    const updated = new Set(prev);
                    updated.add(quote.id);
                    return updated;
                });
            }
            setExpandedQuoteId(null);
        }
    };

    return (
        <div>
            {loadingData ? <Loader /> :
                <div className="admin-tab-content">
                    <div className="admin-bottom-bar">
                        <div className="admin-bottom-bar-left">
                            <input className="admin-default-search quoteradius"
                                type="text"
                                placeholder="search users"
                                id="manufacturer-name"
                                value={filter.search}
                                onChange={(e) => setFilter({ ...filter, search: e.target.value })} />
                        </div>
                        <div className="admin-bottom-bar-right">
                            <label className="admin-large-inline-label" htmlFor="quote-status">Filter Status</label>
                            <QuoteRequestSelect id="quote-status" selectedId={filter.status}
                                onChange={(e) => setFilter({ ...filter, status: parseInt(e.target.value) })} />
                        </div>
                    </div>

                    <div className="admin-table-wrap">
                        <table className="admin-table">
                            <tbody>
                            <tr>
                               <th onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Quote</th>

                                <th onClick={() => setFilter({ ...filter, sort: filter.sort == 12 ? 13 : 12 })} className={filter.sort == 12 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 13 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Project Name</th>

                                <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>User</th>
                                <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Submit Date</th>
                                <th className="admin-table-name-cell">Items in Quote</th>
                                <th onClick={() => setFilter({ ...filter, sort: filter.sort == 6 ? 7 : 6 })} className={filter.sort == 6 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 7 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Status</th>
                                <th className="admin-table-action-cell">&nbsp;</th>
                            </tr>
                                {quotes.results && quotes.results.length > 0 ? (
                                    quotes.results.map((quote, index) => {
                                        const isEditable = quote.subQuotes?.some(sub => sub.status === 0);
                                        const isManuallyCollapsed = manuallyCollapsedQuotes.has(quote.id);
                                        const isExpanded = (isEditable && !isManuallyCollapsed) || expandedQuoteId === quote.id;

                                        return (
                                            <React.Fragment key={quote.id}>
                                                {/* Parent Row */}
                                                <tr
                                                    onClick={() => toggleQuoteExpand(quote, isExpanded, isEditable)}
                                                    className={`clickable-row ${(((quote.status === 0) && quote.subQuotes?.length === 0) || isEditable) ? "gray-tr" : ""}`}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <td className="admin-table-name-cell">{quote.districtId + '-' + ("000" + quote.id).slice(-4)}</td>
                                                    <td className="admin-table-name-cell">{quote.label || 'My Project'}</td>
                                                    <td className="admin-table-name-cell">{quote.email}</td>
                                                    <td className="admin-table-name-cell">{formatDateTimeForUserTimeZone(quote.created)}</td>
                                                    <td className="admin-table-name-cell">{quote.totalQuantity}</td>
                                                    <td className="admin-table-name-cell"
                                                        onClick={(e) => handleStatusClick(e, quote, index)}
                                                        onMouseEnter={() => handleStatusOnEnter(quote, index)}
                                                        onMouseLeave={() => {
                                                            setSelectedStatusRowIndex(null);
                                                        }}
                                                    >
                                                        {quote?.subQuotes?.length > 1 ? (
                                                            <>
                                                                {quote?.subQuotes
                                                                    ?.map(x => x.statusText)
                                                                    ?.filter((value, index, self) => value && self.indexOf(value) === index).length === 1 ?
                                                                    quote?.subQuotes
                                                                        ?.map(x => x.statusText)
                                                                        ?.filter((value, index, self) => value && self.indexOf(value) === index)
                                                                        ?.join(', ') :
                                                                    'Multiple Status'
                                                                }

                                                                {selectedStatusRowIndex === index && (
                                                                    <div className="tr-hover-alert" style={{ display: 'block', minWidth: '21em' }} >
                                                                        <div className='tr-card'>
                                                                            <a
                                                                                className="close-icon"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setSelectedStatusRowIndex(null);
                                                                                }}
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                                    <mask id="mask0_12046_372" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                                                                                        <rect width="18" height="18" fill="#D9D9D9" />
                                                                                    </mask>
                                                                                    <g mask="url(#mask0_12046_372)">
                                                                                        <path d="M9.0001 10.0501L5.3251 13.7251C5.1876 13.8626 5.0126 13.9313 4.8001 13.9313C4.5876 13.9313 4.4126 13.8626 4.2751 13.7251C4.1376 13.5876 4.06885 13.4126 4.06885 13.2001C4.06885 12.9876 4.1376 12.8126 4.2751 12.6751L7.9501 9.0001L4.2751 5.3251C4.1376 5.1876 4.06885 5.0126 4.06885 4.8001C4.06885 4.5876 4.1376 4.4126 4.2751 4.2751C4.4126 4.1376 4.5876 4.06885 4.8001 4.06885C5.0126 4.06885 5.1876 4.1376 5.3251 4.2751L9.0001 7.9501L12.6751 4.2751C12.8126 4.1376 12.9876 4.06885 13.2001 4.06885C13.4126 4.06885 13.5876 4.1376 13.7251 4.2751C13.8626 4.4126 13.9313 4.5876 13.9313 4.8001C13.9313 5.0126 13.8626 5.1876 13.7251 5.3251L10.0501 9.0001L13.7251 12.6751C13.8626 12.8126 13.9313 12.9876 13.9313 13.2001C13.9313 13.4126 13.8626 13.5876 13.7251 13.7251C13.5876 13.8626 13.4126 13.9313 13.2001 13.9313C12.9876 13.9313 12.8126 13.8626 12.6751 13.7251L9.0001 10.0501Z" fill="#1C1B1F" />
                                                                                    </g>
                                                                                </svg>
                                                                            </a>
                                                                            <p className="mb-0">
                                                                                {quote?.subQuotes
                                                                                    ?.map((x, subIndex) => (
                                                                                        <span key={x.id} style={{ display: 'block' }}>{quote.districtId}-{("000" + quote.id).slice(-4)}.{("0" + (subIndex + 1)).slice(-2)}  - {x.statusText}</span>
                                                                                    ))}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </>
                                                        ) : quote?.subQuotes?.length === 1 ? (
                                                            quote.subQuotes[0]?.statusText
                                                        ) : (
                                                            quote?.statusText
                                                        )}
                                                    </td>
                                                    <td className="admin-table-name-cell nowrap"> 
                                                        <Link className="default-cta" to={`/my-quote/${quote.id}`}>
                                                            View/Edit Project
                                                        </Link>
                                                    </td>
                                                </tr>

                                                {/* Subquotes */}
                                                {isExpanded && quote.subQuotes?.map((sub, idx) => (
                                                    <tr key={`sub-${sub.id || idx}`} className="subquote-row">
                                                        <td className="admin-table-name-cell ps-4"> ({quote.districtId}-{("000" + quote.id).slice(-4)}.{("0" + (idx + 1)).slice(-2)})</td>
                                                        <td className="admin-table-name-cell">{sub.label || 'Sub Project'}</td>
                                                        <td className="admin-table-name-cell">{sub.email}</td>
                                                        <td className="admin-table-name-cell">{formatDateTimeForUserTimeZone(sub.created)}</td>
                                                        <td className="admin-table-name-cell">{sub.totalQuantity}</td>
                                                        <td className="admin-table-name-cell">{sub.statusText}</td>
                                                        <td className="admin-table-name-cell nowrap">
                                                            <Link to={`/my-quote/${sub.id}`} target="_blank" rel="noopener noreferrer">
                                                                {(sub.status === 0 || sub.status === 3) ? 'Edit' : 'View'}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td className="admin-table-name-cell" colSpan="7">No active quotes or requests</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {(quotes.total / filter.length) > 1 ? (
                        <div>
                            <button
                                onClick={() => setFilter({ ...filter, start: filter.start - filter.length })}
                                disabled={filter.start == 1}>Previous
                            </button>
                            {generatePageNumbers()}
                            <button
                                onClick={() => setFilter({ ...filter, start: filter.start + filter.length })}
                                disabled={filter.start - 1 + filter.length >= quotes.total}>Next
                            </button>
                        </div>
                    ) : ""

                    }

                    </div>
            }
        </div>
    )
}